
















































































import WarningBanner from '@/components/WarningBanner.vue'
import UploadArticlePanel from '@/components/UploadArticlePanel.vue'
import NotifyMixin from '@/plugins/mixins/NotifyMixin'
import {
  QBtn,
  QCard,
  QDialog,
  QTab,
  QTabPanel,
  QTabPanels,
  QTabs,
} from 'quasar'
import { Component, Mixins, Prop } from 'vue-property-decorator'

enum EUploadTab {
  COMPLETE = 'complete',
  MINIMAL = 'minimal'
}

enum EUploadState {
  ANALYZE = 'analyze',
  CONFIRM = 'confirm'
}

@Component({
  components: {
    WarningBanner,
    QBtn,
    QCard,
    QDialog,
    QTab,
    QTabs,
    QTabPanel,
    QTabPanels,
    UploadArticlePanel,
  },
})
export default class UploadArticleModal extends Mixins(NotifyMixin) {
  @Prop({ required: true, type: Boolean }) public value!: boolean

  public EUploadState = EUploadState
  public EUploadTab = EUploadTab

  public currentTab: EUploadTab = EUploadTab.COMPLETE
  public currentStepCompleteUpload: EUploadState = EUploadState.ANALYZE
  public currentStepMinimalUpload: EUploadState = EUploadState.ANALYZE

  public resetCompleteUpload = false
  public resetMinimalUpload = false

  public confirm(): void {
    // @ts-ignore
    if (this.currentTab === EUploadTab.COMPLETE) this.$refs.completeUpload.handleAdded()
    // @ts-ignore
    if (this.currentTab === EUploadTab.MINIMAL) this.$refs.minimalUpload.handleAdded()
  }

  get uploadLink(): string {
    let baseUrl = process.env.VUE_APP_API_URL! + '/content/csv'
    if (this.currentTab === EUploadTab.MINIMAL) baseUrl += '/minimal'
    if (this.currentStepMinimalUpload === EUploadState.CONFIRM ||
            this.currentStepCompleteUpload === EUploadState.CONFIRM) { baseUrl += '?commit=true' }

    return baseUrl
  }

  get templateLink(): string {
    return this.uploadLink + '?template=true'
  }

  get open(): boolean {
    return this.value
  }

  set open(v: boolean) {
    this.$emit('input', v)
  }

  public async close(): Promise<void> {
    // reset uploader
    this.resetCompleteUpload = true
    this.resetMinimalUpload = true
    this.currentTab = EUploadTab.COMPLETE

    // NextTick so the watch has enough time to trigger
    await this.$nextTick((): void => {
      this.open = false
    })
  }

  public handleTabTranstion(newTab: EUploadTab): void {
    if (newTab === EUploadTab.MINIMAL) {
      this.currentStepCompleteUpload = EUploadState.ANALYZE
    }

    this.currentStepMinimalUpload = EUploadState.ANALYZE
  }
}
